import { render } from "./LesPublications.vue?vue&type=template&id=469c72ae&scoped=true&ts=true"
import script from "./LesPublications.vue?vue&type=script&lang=ts"
export * from "./LesPublications.vue?vue&type=script&lang=ts"

import "./LesPublications.vue?vue&type=style&index=0&id=469c72ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469c72ae"]])

export default __exports__